<template>
    <div class="animated fadeIn">
        <EventDateBookingList
                :searchArgs="[
                        {
                            key: 'userId',
                            value: Core.Session.AuthUser.id
                        },
                        {
                            key: 'start',
                            value: Core.Date.getToday()
                        }
                    ]">
        </EventDateBookingList>
    </div>
</template>

<script>
    import EventDateBookingList from './EventDateBookingList'
    export default {
        name: 'MyBookingList',
        components: {
            EventDateBookingList
        },
        props: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        methods: {
        }
    }
</script>
